// extracted by mini-css-extract-plugin
module.exports = {"blogReviewer":"az_Ho","reviewerText":"az_Io","withVerticalPadding":"az_Jo","withDate":"az_Ko"};